import { apiClient } from './client';
import { Notification, PaginatedResponse } from '../../types/api';

export interface NotificationFilters {
  skip?: number;
  limit?: number;
  is_read?: boolean;
  type?: string;
}

export const notificationsApi = {
  async getNotifications(
    filters?: NotificationFilters
  ): Promise<PaginatedResponse<Notification>> {
    const params = new URLSearchParams();
    if (filters?.skip !== undefined) params.append('skip', filters.skip.toString());
    if (filters?.limit !== undefined) params.append('limit', filters.limit.toString());
    if (filters?.is_read !== undefined) params.append('is_read', filters.is_read.toString());
    if (filters?.type) params.append('type', filters.type);
    const response = await apiClient.get(`/notifications/?${params.toString()}`);
    const data = response.data;
    const items: Notification[] = Array.isArray(data) ? data : data.items || [];
    const total: number = data.total ?? items.length;
    return {
      items,
      total,
      page: 1,
      size: items.length,
      pages: 1,
    };
  },

  async getUnreadCount(): Promise<{ count: number }> {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data;
  },

  async markAsRead(id: string): Promise<void> {
    await apiClient.put(`/notifications/${id}/read`);
  },

  async markAllAsRead(): Promise<void> {
    await apiClient.put('/notifications/read-all');
  },

  async deleteNotification(id: string): Promise<void> {
    await apiClient.delete(`/notifications/${id}`);
  },

  async createAnnouncement(data: {
    title: string;
    message: string;
  }): Promise<Notification> {
    const response = await apiClient.post('/notifications/announcements', data);
    return response.data;
  },
};
